<template>
  <div>
    <BreadCrumd :title="'Stocks'" :description="'Stocks des articles'" />
    <div class="mt-2 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div
              class="col-md-6 col-lg-3"
              v-if="stockType !== 'stock' && stockType !== 'stock_lot'"
            >
              <multiselect
                v-model="selectedEntrepots"
                :options="entrepots"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Filtrer par entrepôt"
                label="nom"
                track-by="nom"
                @input="updateSelectEntrepot"
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length && !isOpen"
                    >{{ values.length }}
                    {{ values.length > 1 ? ' Sélections' : 'Sélection' }}
                  </span>
                </template>
              </multiselect>
            </div>
            <div class="col-md-6 col-lg-3">
              <multiselect
                v-model="selectedFamilles"
                :options="familles"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Filtrer par famille"
                label="nom"
                track-by="nom"
                @input="updateSelectFamille"
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length && !isOpen"
                    >{{ values.length }}
                    {{ values.length > 1 ? ' Sélections' : 'Sélection' }}
                  </span>
                </template>
              </multiselect>
            </div>
            <div
              class="text-lg-right"
              :class="
                stockType === 'stock' || stockType === 'stock_lot'
                  ? 'col-md-12 col-lg-9'
                  : 'col-md-12 col-lg-6'
              "
            >
              <div class="form-check form-check-inline">
                <div class="custom-control custom-radio form-check-inline">
                  <input
                    type="radio"
                    id="stock"
                    name="customRadio"
                    class="custom-control-input"
                    v-model="stockType"
                    value="stock"
                    @change="onChangeFilter"
                  />
                  <label class="custom-control-label" for="stock">Stock</label>
                </div>
              </div>
              <div class="form-check form-check-inline mr-4">
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="stock_entrepot"
                    name="customRadio"
                    v-model="stockType"
                    class="custom-control-input"
                    value="stock_entrepot"
                    @change="onChangeFilter"
                  />
                  <label class="custom-control-label" for="stock_entrepot"
                    >Stock / entrepôt</label
                  >
                </div>
              </div>
              <div class="form-check form-check-inline">
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="stock_lot"
                    name="customRadio"
                    class="custom-control-input"
                    v-model="stockType"
                    value="stock_lot"
                    @change="onChangeFilter"
                  />
                  <label class="custom-control-label" for="stock_lot"
                    >Stock / lot</label
                  >
                </div>
              </div>
              <div class="form-check form-check-inline">
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="stock_entrepot_lot"
                    name="customRadio"
                    class="custom-control-input"
                    v-model="stockType"
                    value="stock_entrepot_lot"
                    @change="onChangeFilter"
                  />
                  <label class="custom-control-label" for="stock_entrepot_lot"
                    >Stock / entrepôt / lot</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <DataTable :headers="selectedHeaders" ref="datatable" />
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import URL from '@/http/article_stock/stock';

export default {
  data() {
    return {
      title: 'Gestion des stocks',
      isSelect: false,
      selectedFamilles: [],
      selectedEntrepots: [],
      selectedHeaders: [],
      entrepots: [],
      familles: [],
      stockType: 'stock',
      stockHeaders: [
        {
          text: 'Référence',
          align: 'start',
          sortable: true,
          value: 'reference',
        },
        {
          text: 'Désignation',
          align: 'start',
          sortable: true,
          value: 'designation',
        },
        {
          text: 'Famille',
          align: 'start',
          sortable: true,
          value: 'famille',
        },
        {
          text: 'Quantité',
          align: 'start',
          sortable: true,
          value: 'quantite',
        },
      ],
      stockEntrepotHeaders: [
        {
          text: 'Référence',
          align: 'start',
          sortable: true,
          value: 'reference',
        },
        {
          text: 'Désignation',
          align: 'start',
          sortable: true,
          value: 'designation',
        },
        {
          text: 'Famille',
          align: 'start',
          sortable: true,
          value: 'famille',
        },
        {
          text: 'Entrepôt',
          align: 'start',
          sortable: true,
          value: 'entrepot',
        },
        {
          text: 'Quantité',
          align: 'start',
          sortable: true,
          value: 'quantite',
        },
      ],
      stockLotHeaders: [
        {
          text: 'Référence',
          align: 'start',
          sortable: true,
          value: 'reference',
        },
        {
          text: 'Désignation',
          align: 'start',
          sortable: true,
          value: 'designation',
        },
        {
          text: 'Famille',
          align: 'start',
          sortable: true,
          value: 'famille',
        },
        {
          text: 'N° Lot',
          align: 'start',
          sortable: true,
          value: 'lot',
        },
        {
          text: 'DLC',
          align: 'start',
          sortable: true,
          value: 'dlc',
        },
        {
          text: 'DLUO',
          align: 'start',
          sortable: true,
          value: 'dluo',
        },
        {
          text: 'Quantité',
          align: 'start',
          sortable: true,
          value: 'quantite',
        },
      ],
      stockEntrepotLotHeaders: [
        {
          text: 'Référence',
          align: 'start',
          sortable: true,
          value: 'reference',
        },
        {
          text: 'Désignation',
          align: 'start',
          sortable: true,
          value: 'designation',
        },
        {
          text: 'Famille',
          align: 'start',
          sortable: true,
          value: 'famille',
        },
        {
          text: 'Entrepôt',
          align: 'start',
          sortable: true,
          value: 'entrepot',
        },
        {
          text: 'N° Lot',
          align: 'start',
          sortable: true,
          value: 'lot',
        },
        {
          text: 'DLC',
          align: 'start',
          sortable: true,
          value: 'dlc',
        },
        {
          text: 'DLUO',
          align: 'start',
          sortable: true,
          value: 'dluo',
        },
        {
          text: 'Quantité',
          align: 'start',
          sortable: true,
          value: 'quantite',
        },
      ],
    };
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DataTable,
  },
  methods: {
    headerSelection() {
      if (this.stockType === 'stock_entrepot') {
        this.headers = this.stockEntrepotHeaders;
        this.selectedHeaders = this.headers;
      } else if (this.stockType === 'stock_lot') {
        this.headers = this.stockLotHeaders;
        this.selectedHeaders = this.headers;
      } else if (this.stockType === 'stock_entrepot_lot') {
        this.headers = this.stockEntrepotLotHeaders;
        this.selectedHeaders = this.headers;
      } else {
        this.headers = this.stockHeaders;
        this.selectedHeaders = this.headers;
      }
    },
    updateSelectEntrepot() {
      this.onChangeFilter();
    },
    updateSelectFamille() {
      this.onChangeFilter();
    },
    onChangeFilter() {
      this.headerSelection();
      let entrepotIds = this.selectedEntrepots.map((a) => a.uuid);
      let familleIds = this.selectedFamilles.map((a) => a.uuid);
      this.$refs.datatable.setFilter(familleIds, entrepotIds, this.stockType);
      this.$refs.datatable.loadItems();
    },
    init() {
      this.headerSelection();
      this.entrepots = [];
      this.familles = [];

      window.axios
        .get(URL.GET_REQUIREMENTS)
        .then((resp) => {
          this.entrepots = resp.data.entrepots;
          this.familles = resp.data.familles;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
